import React from 'react';
import gql from 'graphql-tag';
import classNames from 'classnames';
import { AspectRatioBox } from '@moda/om';
import { useParams, Link } from 'react-router-dom';
import { Image } from '../../../Image';
import { hrefFor } from '../../../../routers';
import { TrunkshowCellFragment } from '../../../../generated/types/TrunkshowCellFragment';
import { RelativeTime } from '../../../RelativeTime';
import './TrunkshowCell.scss';

export const TRUNKSHOW_CELL_FRAGMENT = gql`
  fragment TrunkshowCellFragment on Trunkshow {
    id
    slug
    name
    activeEndAt: active_end_i
    primaryImageUrls: primary_image_urls {
      src: main
    }
  }
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  trunkshow: TrunkshowCellFragment;
}

export const TrunkshowCell: React.FC<Props> = ({ className, trunkshow }) => {
  const { vertical = 'women' } = useParams();
  const imageAlt = `${trunkshow.name}`; // TODO: This needs to be meaninful

  const href = hrefFor.TrunkshowPage({
    vertical: vertical,
    trunkshowId: trunkshow.id,
    trunkshowSlug: trunkshow.slug || trunkshow.id
  });

  return (
    <Link className={classNames('TrunkshowCell', className)} to={href || ''} data-pk={trunkshow.id}>
      <AspectRatioBox className="TrunkshowCell__figure" maxHeight={540} maxWidth={340}>
        {trunkshow.primaryImageUrls?.src && (
          <Image
            className="TrunkshowCell__image"
            src={trunkshow.primaryImageUrls.src}
            alt={imageAlt}
          />
        )}
      </AspectRatioBox>

      {trunkshow.activeEndAt && trunkshow.name && (
        <div className="TrunkshowCell__overlay">
          <RelativeTime className="TrunkshowCell__timestamp" timestamp={trunkshow.activeEndAt}>
            Left
          </RelativeTime>

          <h3 className="TrunkshowCell__title">{trunkshow.name}</h3>
        </div>
      )}
    </Link>
  );
};
